import { ProductDetailsModel, ProductInputModel } from '../common';
import * as yup from 'yup';

export const programeNameValidator = yup
  .string()
  .label('Program Name')
  .nullable()
  .required()
  .min(3)
  .max(200)
  .test({
    name: 'validProgName',
    test: (val: string) => {
      return val?.trim().length >= 3;
    },
    message: 'You must name your program request',
  });

export const accountNumberValidator = yup
  .string()
  .label('TMS Number')
  .required()
  .min(1)
  .max(8)
  .test({
    name: 'validTMSNumber',
    test: (val: string) => /^[0-9]{1,8}$/.test(val),
    message:
      '"${value}" is not a valid TMS Number. A TMS Number should have 1 to 8 digits',
  });

export const productDetailsValidator = yup.object<ProductDetailsModel>({
  programName: programeNameValidator,
  accountNumber: accountNumberValidator,
  clientName: yup.string().label('Client Name').required(),
  clientUserName: yup.string().label('User Name').required(),
  clientUserEmail: yup.string().label('Email').email().required(),
  subCode: yup.string().required(),
  submitterName: yup.string().required(),
  submitterEmail: yup.string().required(),
});

export const productInputValidator = yup.object<ProductInputModel>({
  productDetails: productDetailsValidator.required(),
});
